import { Set } from 'immutable';
import { createContext, useContext } from 'react';
import { getAuthUser, getCurrentUserAbilities } from 'app/models/auth/selectors';
import { connect } from 'react-redux';
import { User, Ability } from 'app/constants/schemas';

const AuthUserContext = createContext<{
  authUser: User | null,
  authenticatedAbilities: Set<Ability>;
}>({
  authUser: null,
  authenticatedAbilities: Set<Ability>(),
});

export const AuthUserProvider = connect((state) => ({
  value: {
    authUser: getAuthUser(state) ?? null,
    authenticatedAbilities: getCurrentUserAbilities(state),
  },
}))(AuthUserContext.Provider);

export const useAuthUser = () => useContext(AuthUserContext).authUser;
export const useCurrentUserAbilities = () => useContext(AuthUserContext).authenticatedAbilities;
